
export function getPostIdFromUrl(url) {
    if (url === null) {
        return null;
    }
    if (url.length <= 6) {
        return url;
    }
    let urlRe = '(?:comments\\/)([^\\/]*)'
    if (url.length <= 23) {
        urlRe = '(?:\\.it\\/)([^\\/]*)'
    }

    let matches = url.match(urlRe)
    if (!matches) {
        return null;
    }
    return matches[1];
}

export function hammingDistance(hashA, hashB) {
    let distance = 0;
    if (hashA.length !== hashB.length) {
        throw new Error('Hashes must be the same length')
    }
    for (let i = 0; i < hashA.length; i++) {
        if (hashA[i].toLowerCase() !== hashB[i].toLowerCase()) {
            distance++;
        }
    }
    return distance;
}

export function makeLoginId(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export function postTypeFromId(id) {
    switch (id) {
        case 1:
            return 'Text'
        case 2:
            return 'Image'
        case 3:
            return 'Link'
        case 4:
            return 'Video'
        case 5:
            return 'Video'
        case 6:
            return 'Gallery'
        case 7:
            return 'Video'
        default:
            console.log(`Unknown post type id ${id}`)
    }
}
